import React, {useMemo} from "react";
import moment from "moment-timezone";
import {useTranslation} from "react-i18next";
import DailyOrderPerformance from "./TablesAndGraphs/Daily/DailyOrderPerformance.jsx";
import DailyCouponPerformance from "./TablesAndGraphs/Daily/DailyCouponPerformance.jsx";
import DailyTopProductPerformance from "./TablesAndGraphs/Daily/DailyTopProductPerformance.jsx";
import DailyCountryPerformance from "./TablesAndGraphs/Daily/DailyCountryPerformance.jsx";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import DailyPaymentPerformance from "./TablesAndGraphs/Daily/DailyPaymentPerformance.jsx";
import DailyShippingPerformance from "./TablesAndGraphs/Daily/DailyShippingPerformance.jsx";
import DailyTopChannelPerformance from "./TablesAndGraphs/Daily/DailyTopChannelPerformance.jsx";


export default function DailyOverview({project}) {

    let {t} = useTranslation();

    let now = useMemo(() => moment(), []);
    let yesterday = useMemo(() => moment().subtract(1, 'day'), []);

    // noinspection JSValidateTypes
    return <
        OrderDashboardLayout
        title={t('route.daily-metrics')}
        hideFilters={true}
    >
        <div className={'col-span-12'}>
            <div className={'grid grid-cols-12 gap-3 sm:gap-6 mb-3 sm:mb-6'}>

                {/* Performance TODAY */}
                <DailyOrderPerformance
                    day={now}
                    title={t('orders.today-performance')}
                    project={project}
                />

                {/* Performance YESTERDAY */}
                <DailyOrderPerformance
                    day={yesterday}
                    title={t('orders.yesterday-performance')}
                    project={project}
                />

            </div>

            <div className={'grid grid-cols-12 gap-3 sm:gap-6 mb-3 sm:mb-6'}>
                <DailyTopChannelPerformance
                    day={now}
                    title={t('orders.top-channels-today')}
                    project={project}
                />
                <DailyTopChannelPerformance
                    day={yesterday}
                    title={t('orders.top-channels-yesterday')}
                    project={project}
                />
            </div>

            <div className={'grid grid-cols-12 gap-3 sm:gap-6 mb-3 sm:mb-6'}>
                <DailyTopProductPerformance
                    day={now}
                    title={t('orders.top-20-products-today')}
                    project={project}
                />
                <DailyTopProductPerformance
                    day={yesterday}
                    title={t('orders.top-20-products-yesterday')}
                    project={project}
                />
            </div>

            <div className={'grid grid-cols-12 gap-3 sm:gap-6 mb-3 sm:mb-6'}>
                <DailyCouponPerformance
                    day={now}
                    title={t('orders.today-coupons')}
                    project={project}
                />
                <DailyCouponPerformance
                    day={yesterday}
                    title={t('orders.yesterday-coupons')}
                    project={project}
                />
            </div>

            <div className={'grid grid-cols-12 gap-3 sm:gap-6 mb-3 sm:mb-6'}>
                <DailyCountryPerformance
                    day={now}
                    title={t('orders.orders-by-country')}
                    project={project}
                />
                <DailyPaymentPerformance
                    day={now}
                    title={t('orders.orders-by-payment')}
                    project={project}
                />
                <DailyShippingPerformance
                    day={now}
                    title={t('orders.orders-by-shipping')}
                    project={project}
                />
                {/* -- -- -- -- -- -- */}
                <DailyCountryPerformance
                    day={yesterday}
                    title={t('orders.orders-by-country')}
                    project={project}
                />
                <DailyPaymentPerformance
                    day={yesterday}
                    title={t('orders.orders-by-payment')}
                    project={project}
                />
                <DailyShippingPerformance
                    day={yesterday}
                    title={t('orders.orders-by-shipping')}
                    project={project}
                />

            </div>

        </div>
    </OrderDashboardLayout>;
}
